import React from "react";
import { Phone, Mail, MapPin, Clock } from "lucide-react";
import { Overline } from "@/components/common";
import { LineReveal, Reveal } from "@/lib/motion";
import ContactForm from "@/components/ContactForm";
import { COMPANY } from "@/data/site";

export default function Contact() {
  return (
    <section className="relative min-h-screen bg-[#0A1128] pt-32 text-white md:pt-40">
      <div className="noise" />
      <div className="container-x relative grid gap-16 pb-24 lg:grid-cols-12 lg:gap-10">
        {/* Left */}
        <div className="lg:col-span-5">
          <Overline dark>Contact Us</Overline>
          <h1 className="mt-6 font-display text-6xl font-bold uppercase leading-[0.9] tracking-tighter md:text-8xl">
            <LineReveal start lines={["Let's", "Talk."]} />
          </h1>
          <p className="mt-8 max-w-md text-base leading-relaxed text-slate-300">
            Request a call back or send us the details of your project. We serve industrial and commercial clients
            across {COMPANY.region}.
          </p>

          <div className="mt-12 space-y-6 border-t border-white/10 pt-10">
            <a href={`mailto:${COMPANY.email}`} data-testid="contact-page-email" className="group flex items-start gap-4">
              <span className="flex h-10 w-10 shrink-0 items-center justify-center bg-white/5"><Mail size={18} className="text-[#4b6bd6]" /></span>
              <span>
                <span className="block text-xs uppercase tracking-widest text-slate-500">Email</span>
                <span className="text-lg text-white underline-offset-2 group-hover:underline">{COMPANY.email}</span>
              </span>
            </a>
            <div className="flex items-start gap-4">
              <span className="flex h-10 w-10 shrink-0 items-center justify-center bg-white/5"><Phone size={18} className="text-[#4b6bd6]" /></span>
              <span>
                <span className="block text-xs uppercase tracking-widest text-slate-500">Phone</span>
                <a href={COMPANY.phoneHref} data-testid="contact-page-phone" className="text-lg text-white underline-offset-2 hover:underline">{COMPANY.phone}</a>
              </span>
            </div>
            <div className="flex items-start gap-4">
              <span className="flex h-10 w-10 shrink-0 items-center justify-center bg-white/5"><MapPin size={18} className="text-[#4b6bd6]" /></span>
              <span>
                <span className="block text-xs uppercase tracking-widest text-slate-500">Office</span>
                <span className="text-lg text-white">{COMPANY.addressLine}</span>
              </span>
            </div>
            <div className="flex items-start gap-4">
              <span className="flex h-10 w-10 shrink-0 items-center justify-center bg-white/5"><Clock size={18} className="text-[#4b6bd6]" /></span>
              <span>
                <span className="block text-xs uppercase tracking-widest text-slate-500">Response time</span>
                <span className="text-lg text-white">We aim to respond within 1 business day.</span>
              </span>
            </div>
          </div>
        </div>

        {/* Right — form */}
        <div className="lg:col-span-6 lg:col-start-7">
          <Reveal>
            <div className="bg-white p-8 md:p-12">
              <ContactForm />
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
